import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import PageBase from 'components/common/PageBase';
import syles from './styles/NotFoundPageStyles';

class NotFoundPage extends Component {
    render() {

        return (
            <PageBase title={"Page not found!"} showGoToButtons={false} >
                <div style={syles.content}>
                    <h1>404</h1>
                    <h2>The page you request does not exist</h2>
                </div>
            </PageBase>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code
    };
}


export default connect(mapStateToProps)(NotFoundPage);


// WEBPACK FOOTER //
// ./src/pages/404/NotFoundPage.js